import React, { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Col, Container, Row } from 'reactstrap'
import dashboards from '../dashboards'
import dashboardsAdministration from '../dashboardsAdministration'
import { dashboardsAccess, hasSettingsView } from '../Helpers'
import { useTranslation } from 'react-i18next'
import { useUserContext } from '../hooks/useUser'

const Portal = () => {
  const { user } = useUserContext()
  const { t } = useTranslation(['portal'])
  const navigate = useNavigate()

  useEffect(() => {
    if (!user) {
      navigate('/login')
    } else if (
      user?.attributes['custom:entity'] === 'ADMIN_DEALER' ||
      user?.attributes['custom:entity'] === 'ADMIN_RBU'
    ) {
      navigate('/members')
    }
  }, [navigate, user])

  const visibleFeatures = useMemo(() => {
    if (!user) return []
    return dashboards.filter(d => dashboardsAccess(user, d))
  }, [user])

  const visibleAdmin = useMemo(() => {
    if (!user) return []

    const isAdminCardVisible = (d) => {
      if (d.value === 'setting') {
        return hasSettingsView(user)
      }
      return dashboardsAccess(user, d)
    }

    return dashboardsAdministration.filter(isAdminCardVisible)
  }, [user])

  return (
    <div className="app portal">
      <Container>
        <Row>
          <Col xs="12">
            <h1>{t('portalsHeader')}</h1>
            <p>
              {t('portalsDescription')}
              <br />
              <br />
              {t('portalsDescription2')}
            </p>
          </Col>
          {user && visibleFeatures.length > 0 && (
            <>
              <Col xs="12">
                <h2>{t('portalsFeaturesTitle')}</h2>
              </Col>
              {visibleFeatures.map((dashboard, index) => (
                <Col xs="12" md="4" key={index}>
                  <div
                    className="site-card"
                    data-testid={dashboard.testId}
                    data-url={dashboard.url}
                    onClick={() => (window.location = dashboard.url)}
                  >
                    <img src={dashboard.img} alt={dashboard.name} />
                    <div className="site-card-desc">
                      <h2>{t(dashboard.label)}</h2>
                      <p>{t(dashboard.desc)}</p>
                    </div>
                  </div>
                </Col>
              )
              )}
            </>
          )}
          {user && visibleAdmin.length > 0 && (
            <>
              <Col className="administration-title" xs="12">
                <h2>{t('portalsAdminTitle')}</h2>
              </Col>
              {visibleAdmin.map((dashboard, index) => (
                <Col xs="12" md="4" key={index}>
                  <div
                    className="site-card"
                    data-testid={dashboard.testId}
                    data-url={dashboard.url}
                    onClick={() => (window.location = dashboard.url)}
                  >
                    <img src={dashboard.img} alt={dashboard.name} />
                    <div className="site-card-desc">
                      <h2>{t(dashboard.label)}</h2>
                      <p>{t(dashboard.desc)}</p>
                    </div>
                  </div>
                </Col>
              )
              )}
            </>
          )}
        </Row>
      </Container>
    </div>
  )
}

export default Portal
